import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { collarProductIsSupportedInCountry, useLocale } from '../../contexts/LocaleContext';
import { ultraCollarId } from '../../types';

export default function useUltraExperienceGuard(): boolean {
  const history = useHistory();
  const { country } = useLocale();

  const isUltraSupportedInCountry = collarProductIsSupportedInCountry(ultraCollarId, country);

  useEffect(() => {
    if (!isUltraSupportedInCountry) {
      history.replace(AppPaths.Products('smart-collar-v3b'));
    }
  }, [isUltraSupportedInCountry, history]);

  return isUltraSupportedInCountry;
}
